import { loadingAnimation } from 'components/Loader/styled'
import styled, { css } from 'styled-components'

const shimmer = css`
  animation: ${loadingAnimation} 1.5s infinite;
  background: linear-gradient(
    to left,
    ${({ theme }) => theme.cardSecondary} 25%,
    ${({ theme }) => theme.hoverState} 50%,
    ${({ theme }) => theme.cardSecondary} 75%
  );
  background-size: 400%;
`

const Bar = styled.div<{ $width: string; $height?: string }>`
  ${shimmer};
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height ?? '12px'};
  border-radius: 6px;
`

const Logo = styled.div`
  ${shimmer};
  width: 32px;
  height: 32px;
  border-radius: 50%;
`

const Lines = styled.div<{ $align?: 'flex-end' }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => $align ?? 'flex-start'};
  gap: 6px;
  min-width: 0;
`

// Mirrors MenuItem's geometry without its hover and click affordances.
const Row = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-gap: 12px;
  align-items: center;
  height: 52px;
  padding: 8px;
`

const SectionTitle = styled.div`
  padding: 12px 8px 4px;
`

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 12px;
  padding-right: 10px;
`

// Varying widths read as real token names instead of identical stripes.
const NAME_WIDTHS = ['45%', '60%', '35%', '55%', '40%', '65%', '50%', '38%']

/** Placeholder shaped like the token list, shown until its first data arrives. */
export default function TokenListSkeleton() {
  return (
    <Rows aria-busy="true" aria-label="Loading tokens">
      <SectionTitle>
        <Bar $width="120px" $height="14px" />
      </SectionTitle>
      {NAME_WIDTHS.map((nameWidth, index) => (
        <Row key={index}>
          <Logo />
          <Lines>
            <Bar $width={nameWidth} $height="14px" />
            <Bar $width="110px" />
          </Lines>
          <Lines $align="flex-end">
            <Bar $width="56px" $height="14px" />
          </Lines>
        </Row>
      ))}
    </Rows>
  )
}
